type ChatJob = {
  jobId: string;
  conversationId: string;
};

const chatJob: ChatJob = {
  jobId: "",
  conversationId: "",
};

export type { ChatJob };

export { chatJob };
